import { GridItem, Text } from '@chakra-ui/react';
import { CostUnitType, LineItem } from '@pelicargo/types';
import { prettyCurrency, prettyNumber } from '@pelicargo/utils';
import { getPrettySurchargeUnit } from '@pelicargo/utils';
import { Fragment } from 'react';

export const LineItemUI = ({ lineItem }: { lineItem: LineItem }) => {
  const isPercentage = lineItem?.per_unit_cost_type === CostUnitType.PERCENTAGE;

  const formattedPerUnitValue = isPercentage
    ? ''
    : `${prettyCurrency(lineItem?.per_unit_cost)}/${getPrettySurchargeUnit(lineItem?.per_unit_count_type)}`;
  const perUnitValue = lineItem?.per_unit_cost ? formattedPerUnitValue : '';

  const displayChargeableWeight = !!lineItem?.per_unit_cost && lineItem?.per_unit_cost_type !== CostUnitType.PERCENTAGE;
  const formattedChargeableWeight =
    lineItem?.per_unit_count && displayChargeableWeight
      ? `${prettyNumber(lineItem.per_unit_count)} ${getPrettySurchargeUnit(lineItem?.per_unit_count_type)}`
      : '';

  return (
    <Fragment key={lineItem?.id}>
      <GridItem pl="4" colSpan={2} py={0.5}>
        <Text textStyle="bodySmallRegular">{lineItem?.label}</Text>
      </GridItem>
      <GridItem textAlign="right" colSpan={1} py={0.5}>
        <Text textStyle="bodySmallRegular">{formattedChargeableWeight}</Text>
      </GridItem>
      <GridItem textAlign="right" colSpan={1} py={0.5}>
        <Text textStyle="bodySmallRegular">{perUnitValue}</Text>
      </GridItem>
      <GridItem textAlign="right" pr="4" colSpan={1} py={0.5}>
        <Text textStyle="bodySmallRegular">{lineItem.cost ? `${prettyCurrency(lineItem.cost)}` : ''}</Text>
      </GridItem>
    </Fragment>
  );
};
